import { getField, updateField } from 'vuex-map-fields';

export default {
    namespaced: true,

    state: {
        staff: {
            Username: '',
            Email: '',
            Password: '',
            PortalPassword: '',
            PortalPasswordConfirmation: '',
        },
    },

    getters: {
        getField,
    },

    actions: {
        login({ state }) { ///
            return axios.post('/api/admin/login', state.staff);
        },
        signUp({ state }) {
            return axios.post('/api/admin/recover', state.staff);
        },
        activate({ state }, token) {
            return axios.post(`/api/admin/activate/${token}`, state.staff);
        },
    },

    mutations: {
        updateField,
    },
};